import { render, staticRenderFns } from "./right-side.vue?vue&type=template&id=8c6f6a64&"
import script from "./right-side.vue?vue&type=script&lang=js&"
export * from "./right-side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports